<!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -- Backdrop dismiss is pointer-only; not a focusable control -->
<div
  class="overlay"
  (click)="onClick($event)"
>
  @if (!isLoading) {
    <div class="overlay__header"></div>
    <div class="overlay__aside"></div>
    <div class="overlay__content"></div>
  }
  @if (isLoading) {
    <div class="overlay__loading">
      @if (loadingType === overlayService.loadingType.SPINNER) {
        <qima-spinner
          [style.color]="qimaColor.pool.POOL_500"
          [qimaSpinnerUnit]="spinnerService.unit.PIXEL"
          [qimaSpinnerSize]="150"
        ></qima-spinner>
      }
      @if (loadingType === overlayService.loadingType.THREE_SQUARES) {
        <qima-three-squares-loader
          [qimaThreeSquaresLoaderStyle]="threeSquaresLoaderService.style.POOL_500"
          [qimaThreeSquaresLoaderUnit]="threeSquaresLoaderService.unit.PIXEL"
          [qimaThreeSquaresLoaderSize]="120"
        ></qima-three-squares-loader>
      }
    </div>
  }
</div>
